import React from 'react';
import { Switch } from 'antd';
import { Show } from '@frontend/components/atoms/show';
import TruoraAlertNoStock from '../truora-alert-no-stock/TruoraAlertNoStock';
import TruoraAlertCountStock from '../truora-alert-count-stock/TruoraAlertCountStock';
import styles from './TruoraSettingsForm.module.scss';

const MAX_TRUORA_STOCK = 30;

const TruoraSettingsForm = ({ truoraActivation, form, stock }) => {
  return (
    <article>
      <Show when={stock} fallback={<TruoraAlertNoStock />}>
        <Show when={stock < MAX_TRUORA_STOCK}>
          <TruoraAlertCountStock stock={stock} />
        </Show>
      </Show>
      <div className={styles.wrapper}>
        <div>
          <p className={styles.description}>
            Al activar esta sección, podrás consultar en línea los antecedentes
            (penales, judiciales e internacionales) de tus postulantes,
            obteniendo resultados confiables para tomar decisiones y hacer
            crecer tu negocio.
          </p>
          <br />
          <p className={styles.description}>
            Para que la Verificación de Antecedentes se haga efectiva, los
            postulantes deben aceptar la{' '}
            <a
              href="https://www.truora.com/es/aviso-de-privacidad-integral"
              target="_blank"
            >
              Política de Tratamiento y Privacidad de datos
            </a>
            , que se mostrará en la vacante publicada.
          </p>
        </div>
        {form.getFieldDecorator('truora_activation')(
          <Switch defaultChecked={truoraActivation} disabled={!stock}></Switch>
        )}
      </div>
    </article>
  );
};

export default TruoraSettingsForm;
